const bannerposition = {
  getlist: 'bannerposition/getlist',
  add: 'bannerposition/add',
  update: 'bannerposition/update',
  remove: 'bannerposition/remove',
  get: 'bannerposition/get',
  getall: 'bannerposition/getall',
}
export default bannerposition
